<template>
  <v-btn-toggle v-model="selected_index" mandatory dense>
    <v-btn
        v-for="device in devices"
        :key="device.slug"
        small
    >
      <span
          class="device-color-indicator mr-1"
          :style="{ background: get_device_color(device.slug) }"
      ></span>
      {{ device.name }}
      <v-icon v-if="device.released_after_id === null" x-small color="orange darken-1" class="ml-1">mdi-bug</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import {PointsStore} from "@/store";
import {storeToRefs} from 'pinia';

export default {
  name: "DeviceSelector",
  setup() {
    const points_store = PointsStore();
    const {devices, selected_device} = storeToRefs(points_store);
    return {points_store, devices, selected_device};
  },
  computed: {
    selected_index: {
      get() {
        return this.devices.findIndex(d => d.slug === this.selected_device);
      },
      set(index) {
        if (this.devices[index]) {
          this.points_store.select_device(this.devices[index].slug);
        }
      }
    }
  },
  methods: {
    get_device_color(slug) {
      return this.points_store.get_device_color(slug);
    }
  }
}
</script>

<style scoped>
.device-color-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
